define('RestrictedItems.View', [
    'Backbone',
    'SC.Configuration',
    '_restricteditems.tpl',
    'underscore'
], function RestrictedItemsView(
    Backbone,
    Configuration,
    RestrictedItemsViewTpl,
    _
) {
    'use strict';

    return Backbone.View.extend({

        template: RestrictedItemsViewTpl,

        initialize: function initialize(options) {
            this.application = options.application;
        },
        getDataContext: function getDataContext() {
            var pdp = this.application.getComponent('PDP');
            var itemInfo = pdp.getItemInfo();
            var spiritsClassList = Configuration.get('RestrictedItems.Classes');
            var spiritClass = itemInfo.item.class || '';
            var spiritMessage = _.findWhere(spiritsClassList, { class: spiritClass }) || {};
            var isShippingRestriction = itemInfo && itemInfo.item && itemInfo.item.custitem_aws_shipping_restriction;
            var showMessage = !!isShippingRestriction || spiritMessage.message;

            return {
                showMessage: showMessage,
                message: isShippingRestriction && showMessage ? itemInfo.item.custitem_aws_shipping_restriction : spiritMessage.message
            };
        },
        getContext: function getContext() {
            return this.getDataContext();
        }
    });
});
